import {share} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {DemographicReportUrls} from '../api/DemographicReportUrls';
import {
    AllocationReportClient,
    DemographicReportClient, PagedListOfPledgeDemographicDetailReport,
    PagedListOfPledgeDetailReport,
    PledgeReportClient,
    PledgeStatusType
} from './api.client';
import {PledgeZipcodeReport} from './api.client';
import {PledgeCountyReport} from './api.client';
import {PledgeDemographicSummaryReport} from './api.client';
import {PledgeSummaryReport} from './api.client';
import {AllocationReport} from './api.client';
import {FileDownloadService} from './FileDownloadService';

@Injectable()
export class DemographicDemographicReportService {

  constructor(private _demographicReportApiService: DemographicReportClient,
              private _fileDownloadService: FileDownloadService,
              private _agencyReportApiService: PledgeReportClient,
              private _allocationReportService: AllocationReportClient) {
  }

  detailReport({startDate, endDate, pledgeTypeIds, pledgeStatus, companyId, agencyId}: {
    startDate: Date,
    endDate: Date,
    pledgeTypeIds: [],
    pledgeStatus: PledgeStatusType,
    companyId: string,
    agencyId: string
  }): Observable<PagedListOfPledgeDemographicDetailReport> {
    return this._demographicReportApiService
        .detailReport(startDate, endDate, pledgeTypeIds, pledgeStatus, companyId, agencyId).pipe(share());
  }

  agencyDetailReport({startDate, endDate, pledgeTypeIds, pledgeStatus, agencyId, offset, limit, sortName, descending}: {
    startDate: Date,
    endDate: Date,
    pledgeTypeIds: [],
    pledgeStatus: PledgeStatusType,
    companyId: string,
    agencyId: string,
    offset: number,
    limit: number,
    sortName: string,
    descending: boolean
  }): Observable<PagedListOfPledgeDetailReport> {
    return this._agencyReportApiService.detailReport(
        startDate,
        endDate,
        pledgeTypeIds,
        pledgeStatus,
        agencyId,
        limit,
        offset,
        sortName,
        null,
        descending).pipe(share());
  }

  agencySummaryReport({startDate, endDate, pledgeTypeIds, pledgeStatus, agencyId}: {
    startDate: Date,
    endDate: Date,
    pledgeTypeIds: [],
    pledgeStatus: PledgeStatusType,
    companyId: string,
    agencyId: string
  }): Observable<PledgeSummaryReport[]> {
    return this._agencyReportApiService.summaryReport(
        startDate, endDate, pledgeTypeIds, pledgeStatus, agencyId).pipe(share());
  }

  allocationReport({startDate, endDate, pledgeTypeIds, pledgeStatus, agencyId, hideZeroBalances}: {
    startDate: Date,
    endDate: Date,
    pledgeTypeIds: [],
    pledgeStatus: PledgeStatusType,
    companyId: string,
    agencyId: string,
    hideZeroBalances: boolean }): Observable<AllocationReport[]> {
    return this._allocationReportService
        .detailReport(startDate, endDate, pledgeTypeIds, pledgeStatus, agencyId, hideZeroBalances).pipe(share());
  }

  countyReport({startDate, endDate, pledgeTypeIds, pledgeStatus, companyId, agencyId}: {
    startDate: Date,
    endDate: Date,
    pledgeTypeIds: [],
    pledgeStatus: PledgeStatusType,
    companyId: string,
    agencyId: string }): Observable<PledgeCountyReport[]> {
    return this._demographicReportApiService
        .countyReport(startDate, endDate, pledgeTypeIds, pledgeStatus, companyId, agencyId).pipe(share());
  }

  downloadCountyReport(data: {
    startDate: Date,
    endDate: Date,
    pledgeTypeId: string,
    pledgeStatus: PledgeStatusType,
    companyId: string,
    agencyId: string }): string {
    return this._fileDownloadService.buildUrl(DemographicReportUrls.DOWNLOAD_COUNTY_REPORT, data);
  }

  zipcodeReport({startDate, endDate, pledgeTypeIds, pledgeStatus, companyId, agencyId}: {
    startDate: Date,
    endDate: Date,
    pledgeTypeIds: [],
    pledgeStatus: PledgeStatusType,
    companyId: string,
    agencyId: string }): Observable<PledgeZipcodeReport[]> {
    return this._demographicReportApiService
        .zipcodeReport(startDate, endDate, pledgeTypeIds, pledgeStatus, companyId, agencyId).pipe(share());
  }

  summaryReport({startDate, endDate, pledgeTypeIds, pledgeStatus, companyId, agencyId}: {
    startDate: Date,
    endDate: Date,
    pledgeTypeIds: [],
    pledgeStatus: PledgeStatusType,
    companyId: string,
    agencyId: string }): Observable<PledgeDemographicSummaryReport> {
    return this._demographicReportApiService
        .summaryReport(startDate, endDate, pledgeTypeIds, pledgeStatus, companyId, agencyId).pipe(share());
  }

  downloadSummaryReport(data: {
    startDate: Date,
    endDate: Date,
    pledgeTypeId: string,
    pledgeStatus: PledgeStatusType,
    companyId: string,
    agencyId: string }): string {
    return this._fileDownloadService.buildUrl(DemographicReportUrls.DOWNLOAD_SUMMARY_REPORT, data);
  }
}
